// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-gku","largestCol":"styles_largestCol__1m7wP","smallestCol":"styles_smallestCol__2m2hk"};